let errorAuthCounter = 0

export default function(ctx) {
  const axiosAaltra = ctx.$axios.create()
  axiosAaltra.setHeader('Content-Type', 'application/json')

  axiosAaltra.onRequest((config) => {
    switch (ctx.env.envName) {
      case 'master':
        config.baseURL = ctx.env.apiAaltraMaster
        break
      case 'develop':
        config.baseURL = ctx.env.apiAaltraDevelop
        break
      case 'feature':
        config.baseURL = ctx.env.apiAaltraFeature
        break
      default:
        config.baseURL = ctx.env.apiAaltraStaging
    }

    if (!['auth'].includes(config.url)) {
      const token = ctx.$storage.getUniversal('aaltraToken')
      if (token?.length) {
        config.headers.common.authorization = `Bearer ${token}`
      } else {
        console.log('No token in storage')
      }
    }
    // Set cancelToken source to make it possible to cancel requests on route navigation
    const cancelSource = ctx.$axios.CancelToken.source()
    config.cancelToken = cancelSource.token
    ctx.store.commit('axioscancelrequests/setRequestsCancelToken', cancelSource)

    if (
      process.env.NODE_ENV !== 'production' ||
      process.env.envName === 'feature'
    )
      console.log('🚀 Making request to ' + config.baseURL + config.url)
  })

  // Cancel all requests every time the route changes
  ctx.app.router.beforeEach(async (to, from, next) => {
    await ctx.store.dispatch('axioscancelrequests/cancelPendingRequests')
    next()
  })

  axiosAaltra.interceptors.response.use(
    function(resp) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      ctx.store.dispatch('components/handleNetworkError', false)
      errorAuthCounter = 0
      return resp
    },
    async function(err) {
      ctx.$sentry.setExtra('error', err)
      if (err?.response?.data) {
        ctx.$sentry.setExtra('errorData', JSON.parse(err?.response?.data))
      }
      if (err?.response?.status && [500].includes(err?.response?.status)) {
        ctx.$sentry.setTag('owner', 'aaltra')
        ctx.$sentry.captureException(err)
      }

      if (['auth'].includes(err?.config?.url)) {
        errorAuthCounter++
      }

      if (err?.response?.status === 500 && err?.config?.url === 'auth') {
        ctx.store.dispatch('axioscancelrequests/cancelPendingRequests')
        return ctx.app.router.push({
          name: 'landing',
          query: { state: 'energy_not_available' }
        })
      }

      if (err?.response?.status === 401 && !errorAuthCounter) {
        const languageChoice = await ctx.store.dispatch('getLanguageChoice')
        if (err?.config?.url === 'auth') {
          ctx.store.commit('setAuthError', true)
        } else {
          return ctx.app.router.push({
            name: 'launcher',
            query: {
              status: 'energy',
              preferred_language:
                languageChoice?.language || ctx.store.state.fallbackLocale
            }
          })
        }
      }

      if (!err.response || err?.response?.status === 0) {
        // When error has no response it is a network error
        if (
          ctx.store.state.components.hasNavigation &&
          ctx.store.state.components.networkTries < 2
        ) {
          ctx.store.dispatch('components/handleNetworkError', true)
          return
        } else {
          return ctx.error({ statusCode: -1, message: 'Network error' })
        }
      } else {
        ctx.store.dispatch('components/handleNetworkError', false)
      }

      if (err?.response?.status === 500) {
        if (err?.config?.url !== 'live') {
          ctx.store.dispatch('axioscancelrequests/cancelPendingRequests')
          return ctx.app.router.push({
            name: 'landing',
            query: { state: 'energy_not_available' }
          })
        }
      }

      if (
        err &&
        err.response &&
        err.response.status &&
        [401, 403].includes(err.response.status)
      ) {
        if (errorAuthCounter > 1) {
          errorAuthCounter = 0
          ctx.store.dispatch('axioscancelrequests/cancelPendingRequests')
          ctx.$logout('energy', true)
          return ctx.app.router.push({
            name: 'landing',
            query: { state: 'energy_not_available' }
          })
        }
        return ctx.$logout('energy')
      }

      if (err?.response?.status === 400 && err?.response?.data?.errors) {
        return Promise.reject(err)
      }

      if (err?.response?.status === 404) {
        return ctx.error({ statusCode: 404, message: 'API request not found' })
      }

      return Promise.reject(err)
    }
  )

  ctx.$axiosAaltra = axiosAaltra
}
